import { Column, Entity, Index /*ManyToOne, JoinColumn */ } from 'typeorm';
import { EmailProviderType } from '../../enums';
import { BaseEntity } from './base.entity';
// import { UserEntity } from './user.entity';

@Entity('email_provider_connection')
@Index(['userId', 'provider', 'email'], { unique: true })
@Index(['userId', 'isActive'])
export class EmailProviderConnectionEntity extends BaseEntity {
	@Column({ name: 'fk_user__id', type: 'int', unsigned: true })
	public userId!: number;

	// TODO PUT THIS BACK ONCE CRM-API IS USING THE CORRECT USER ENTITY
	/*
@ManyToOne(() => UserEntity)
@JoinColumn({ name: 'fk_user__id' })
  public user!: UserEntity;
  */

	@Column({
		name: 'provider',
		type: 'enum',
		enum: EmailProviderType,
	})
	public provider!: EmailProviderType;

	@Column({ name: 'email', type: 'varchar', length: 320 })
	public email!: string;

	@Column({ name: 'token_expiry', type: 'timestamp', nullable: true })
	public tokenExpiry?: Date;

	@Column({ type: 'json', nullable: true })
	public metadata?: Record<string, any>;

	// HTML signature for this account, injected into the composer when sending
	// from this connection. Stored locally because no provider reliably exposes
	// signatures via API and none auto-append when sending through their API.
	@Column({ name: 'signature', type: 'longtext', nullable: true })
	public signature?: string;

	// When true, the signature is automatically appended to new emails composed
	// from this account. Opt-in so existing connections aren't changed.
	@Column({ name: 'signature_auto_append', type: 'boolean', default: false })
	public signatureAutoAppend!: boolean;

	@Column({ name: 'is_active', type: 'boolean', default: true })
	public isActive!: boolean;
}
